// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrEligibleExpenseDto
 */
export interface IOcrEligibleExpenseDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrEligibleExpenseDto
     */
    patient?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrEligibleExpenseDto
     */
    service?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrEligibleExpenseDto
     */
    amount?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof IOcrEligibleExpenseDto
     */
    service_dates?: Set<string>;
}

/**
 * Check if a given object implements the IOcrEligibleExpenseDto interface.
 */
export function instanceOfIOcrEligibleExpenseDto(value: object): value is IOcrEligibleExpenseDto {
    return true;
}

export function IOcrEligibleExpenseDtoFromJSON(json: any): IOcrEligibleExpenseDto {
    return IOcrEligibleExpenseDtoFromJSONTyped(json, false);
}

export function IOcrEligibleExpenseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrEligibleExpenseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': json['patient'] == null ? undefined : json['patient'],
        'service': json['service'] == null ? undefined : json['service'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'service_dates': json['service_dates'] == null ? undefined : new Set(json['service_dates']),
    };
}

export function IOcrEligibleExpenseDtoToJSON(json: any): IOcrEligibleExpenseDto {
    return IOcrEligibleExpenseDtoToJSONTyped(json, false);
}

export function IOcrEligibleExpenseDtoToJSONTyped(value?: IOcrEligibleExpenseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': value['patient'],
        'service': value['service'],
        'amount': value['amount'],
        'service_dates': value['service_dates'] == null ? undefined : Array.from(value['service_dates'] as Set<any>),
    };
}

